export default {
  首页: "Acasă",
  资产: "Active",
  币币: "Spot",
  快捷买币: "Cumpărare rapidă de criptomonede",
  "支持多种方式购买，购买更简单": "Cumpărați ușor cu mai multe metode de plată",
  语言设置: "Setări limbă",
  确认恢复: "Confirmare recuperare",
  "输入邮箱，方便我们联系您":
    "Introduceți adresa de e-mail pentru a vă putea contacta",
  划转: "Transfer",
  行情: "Piață",
  "24H成交": "Volum 24h",
  累计收益: "Randament total",
  充值时间: "Data depunerii",
  到期时间: "Data expirării",
  数量: "Cantitate",
  操作: "Acțiune",
  资产信息: "Informații active",
  复制地址: "Copiază adresa",
  链名称: "Numele lanțului",
  充值地址: "Adresă de depunere",
  收款地址: "Adresă de primire",
  账单: "Factură",
  提现金额: "Sumă de retragere",
  接收地址: "Adresă de primire",
  交易密码: "Parolă tranzacționare",
  提现全部: "Retrage tot",
  保存图片: "Salvează imaginea",
  输入您的交易密码: "Introduceți parola de tranzacționare",
  确定: "Confirmă",
  地址: "Adresă",
  注册时间: "Data înregistrării",
  取消: "Anulează",
  是否划转: "Transfer?",
  登录: "Autentificare",
  我的地址: "Adresele mele",
  登录密码和交易密码: "Parola de autentificare și parola de tranzacționare",
  注册: "Înregistrare",
  密码: "Parolă",
  设置密码: "Setare parolă",
  重复密码: "Repetă parola",
  新密码: "Parolă nouă",
  确认新密码: "Confirmă parola nouă",
  充值: "Depunere",
  充值货币: "Depunere valută",
  合约账户充值: "Depunere în contul de futures",
  账户充值: "Depunere în cont",
  其他: "Altele",
  我的邀请码: "Codul meu de invitare",
  提现: "Retragere",
  客服: "Serviciu clienți",
  持有详情: "Detalii deținere",
  请输入内容: "Introduceți conținutul",
  邀请好友来领取奖励: "Invitați prieteni și primiți recompense",
  复制链接: "Copiază linkul",
  重复设置新的密码: "Repetă noua parolă",
  保存: "Salvează",
  我的: "Contul meu",
  "邮箱/手机号": "E-mail/Număr de telefon",
  备注: "Observație",
  地址管理: "Gestionare adrese",
  我的团队: "Echipa mea",
  联系我们: "Contactați-ne",
  竭诚为您服务: "Suntem la dispoziția dvs.",
  提取收益: "Retragere randament",
  带给我的收益: "Randament generat",
  添加: "Adaugă",
  名称: "Nume",
  添加地址: "Adaugă adresă",
  修改地址: "Modifică adresă",
  可提现: "Retragere posibilă",
  安全中心: "Centru de securitate",
  收益划转: "Transfer randament",
  通知中心: "Notificări",
  "累计收益:": "Randament total:",
  注册用户: "Utilizatori înregistrați",
  奖励规则: "Reguli de recompensare",
  帮助反馈: "Ajutor și feedback",
  邀请好友: "Invită prieteni",
  恢复身份: "Recuperare identitate",
  选择语言: "Selectare limbă",
  设置新的密码: "Setare parolă nouă",
  暂无活动: "Nicio activitate activă",
  "月增长量(+)": "Creștere lunară (+)",
  可提取: "Extractibil",
  反馈类型: "Tip feedback",
  赠送: "Cadou",
  已经复制: "Copiat",
  保存成功: "Salvat cu succes",
  划转成功: "Transfer realizat cu succes",
  过期: "Expirat",
  提交成功: "Trimis cu succes",
  "服务器繁忙，稍后在试": "Server ocupat, încercați din nou mai târziu",
  全部: "Toate",
  一级: "Nivel 1",
  二级: "Nivel 2",
  三级: "Nivel 3",
  级: "Nivel",
  删除成功: "Șters cu succes",
  选择地址: "Selectați adresa",
  不再提醒: "Nu mai afișa",
  "最小充值金额：": "Suma minimă de depunere:",
  选择币种: "Selectați criptomoneda",
  输入投资金额: "Introduceți suma de investiție",
  输入账户密码: "Introduceți parola contului",
  投资: "Investește",
  订单编号: "Număr comandă",
  投资周期: "Perioadă de investiție",
  投资资金: "Sumă investită",
  投资时间: "Timpul investiției",
  状态: "Status",
  投资中: "Activ",
  已到期: "Expirat",
  暂无数据: "Nu există date",
  转入: "Transfer către",
  邮箱: "E-mail",
  请输入邮箱: "Introduceți adresa de e-mail",
  请输入格式正确的邮箱: "Introduceți o adresă de e-mail validă",
  请输入验证码: "Introduceți codul de verificare",
  获取验证码: "Obțineți codul de verificare",
  请输入邀请码: "Introduceți codul de invitație",
  今天: "Astăzi",
  昨天: "Ieri",
  最近七天: "Ultimele 7 zile",
  邀请: "Invită",
  购买数量: "Cantitate de cumpărare",
  产品详情: "Detalii produs",
  币种: "Criptomonedă",
  利息币种: "Moneda randamentului",
  理财类型: "Tip produs financiar",
  产品费率: "Costuri produs",
  进行中: "Activ",
  每天: "Zilnic",
  请输入搜索关键词: "Introduceți cuvântul cheie",
  通知: "Notificări",
  查看更多: "Vezi mai multe",
  理财宝: "Produse financiare",
  周期: "Durată",
  年利率: "Rată anuală a dobânzii (APY)",
  更多产品: "Mai multe produse",
  灵活存取: "Economii flexibile",
  稳定收益: "Randament stabil",
  合约指南: "Ghid futures",
  资金划转出: "Transfer ieșire",
  矿池收益: "Recompensă mining",
  提现手续费: "Comision retragere",
  冻结资金: "Fonduri înghețate",
  解冻资金: "Dezghețare fonduri înghețate",
  闪兑支出: "Cheltuială schimb rapid",
  闪兑收入: "Venit din schimb rapid",
  闪兑手续费: "Comision schimb rapid",
  合约支出: "Cheltuială futures",
  合约收入: "Venit futures",
  输入的金额不可大于可用金额: "Suma nu poate depăși suma disponibilă",
  全部兑换成功: "Schimb total realizat cu succes",
  返回: "Înapoi",
  查看历史: "Vezi istoricul",
  闪兑历史: "Istoric schimb rapid",
  支付: "Plătește",
  获取: "Obține",
  时间: "Timp",
  手续费: "Comision tranzacție",
  折扣: "Reducere",
  价格: "Preț",
  逐仓: "Marjă izolată",
  全仓: "Marjă încrucișată",
  市价委托: "Ordin de piață",
  限价委托: "Ordin limită",
  请输入本金: "Introduceți principalul",
  请输入价格: "Introduceți prețul",
  "可做空/做多": "Posibil short/long",
  设置止盈止损: "Setați take-profit/stop-loss",
  止盈价: "Preț take-profit",
  止损价: "Preț stop-loss",
  成本: "Preț de cost",
  做多: "Long",
  做空: "Short",
  仓位信息: "Informații poziție",
  一键平仓: "Închide poziția (un clic)",
  永续: "Perpetual",
  浮动盈亏: "Profit/pierdere nerealizat",
  平仓: "Închide poziția",
  反向开仓: "Deschide poziție inversă",
  一键撤销: "Anulează tot (un clic)",
  倍杠杆: "x efect de levier",
  执行价格: "Preț de execuție",
  委托数量: "Cantitate ordin",
  保证金: "Marjă",
  成交价: "Preț de execuție",
  创建时间: "Timp creare",
  撤销: "Anulează",
  合约市场: "Piața futures",
  交易方向: "Direcție tranzacționare",
  委托价格: "Preț ordin",
  委托金额: "Sumă ordin",
  资金费率: "Rată de finanțare",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Comision periodic plătit de pozițiile long și short, decontat la fiecare 8 ore.",
  "资金费率为正，多方向空方支付资金费用。":
    "Cu o rată de finanțare pozitivă, pozițiile long plătesc pozițiilor short.",
  "资金费率为负，空方向多方支付资金费用。":
    "Cu o rată de finanțare negativă, pozițiile short plătesc pozițiilor long.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Sigur doriți să deschideți o poziție inversă? Aceasta va cumpăra direcția opusă poziției dvs. actuale.",
  "仓位止盈/止损": "Take-profit/Stop-loss pentru poziție",
  合约名称: "Contract futures",
  开仓价格: "Preț de deschidere",
  指数价格: "Preț index",
  止盈设置: "Setări take-profit",
  请输入止盈价: "Introduceți prețul take-profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Când prețul indexului atinge *, va fi declanșat un ordin de închidere.",
  预计盈亏: "Profit/pierdere așteptat",
  当前仓位: "Poziția curentă",
  平仓金额: "Sumă de închidere",
  仓位模式: "Mod poziție",
  全仓模式: "Mod marjă încrucișată",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "În modul marjă încrucișată, toate fondurile disponibile din contul dvs. de futures sunt utilizate ca marjă. Lichidarea are loc atunci când pierderea depășește soldul total, rezultând pierderea întregii marje și a poziției.",
  逐仓模式: "Mod marjă izolată",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "O anumită sumă de marjă este alocată unei poziții. Dacă pierderea marjei scade sub nivelul marjei de menținere, poziția este lichidată. În modul izolat, puteți crește sau micșora marja pentru această poziție.",
  "是否撤销？": "Anulați ordinul?",
  "是否一键撤销？": "Anulați toate ordinele?",
  "是否一键平仓？": "Închideți toate pozițiile?",
  持仓保证金: "Marja poziției curente",
  风险率: "Rată de risc",
  未实现盈亏: "Profit/pierdere nerealizat",
  可用保证金: "Marjă disponibilă",
  净值: "Valoare netă",
  账户余额: "Sold cont",
  合约计算器: "Calculator futures",
  交易记录: "Istoric tranzacții",
  "*倍杠杆": "*x efect de levier",
  "平仓盈亏：": "Profit/pierdere realizat:",
  时间筛选: "Filtru timp",
  仓位类型: "Tip poziție",
  订单状态: "Status comandă",
  订单类型: "Tip ordin",
  平仓价格: "Preț de închidere",
  持仓数量: "Cantitate poziție",
  "手续费(%)": "Comision tranzacție (%)",
  平仓时间: "Timp închidere",
  平仓类型: "Tip închidere",
  手动平仓: "Închidere manuală",
  强制平仓: "Lichidare forțată",
  近1天: "Ultima zi",
  近7天: "Ultimele 7 zile",
  近30天: "Ultimele 30 de zile",
  近180天: "Ultimele 180 de zile",
  持仓: "Poziție deschisă",
  已取消: "Anulat",
  分时: "Intrazilnic",
  "24H额(USDT)": "Volum 24h (USDT)",
  "24H低": "Minim 24h",
  "24H量(BTC)": "Volum 24h (BTC)",
  "24H高": "Maxim 24h",
  "10秒": "10 secunde",
  "30秒": "30 secunde",
  "1分": "1 minut",
  "3分": "3 minute",
  "5分": "5 minute",
  "30分": "30 minute",
  "1小时": "1 oră",
  "4小时": "4 ore",
  "8小时": "8 ore",
  "1天": "1 zi",
  "1周": "1 săptămână",
  "1月": "1 lună",
  单向持仓: "Poziție unidirecțională",
  杠杆: "Efect de levier",
  仓位: "Poziție",
  计算结果: "Rezultat",
  盈亏: "Profit/Pierdere",
  收益率: "Randament",
  计算结果仅供参考: "Rezultatul este orientativ",
  成交后仓位大小: "Mărimea poziției după execuție",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Rezultatul este orientativ, rezultatele reale pot varia din cauza comisioanelor.",
  目标价格: "Preț țintă",
  开始计算: "Calculează",
  强平价格: "Preț de lichidare",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Verificați cu atenție numele lanțului înainte de depunere. Depunerile greșite nu pot fi anulate. Suma minimă de depunere este *. Depunerile sub această sumă nu vor fi procesate. Nu trimiteți alte active la această adresă. Nu utilizați adrese ICO sau de crowdfunding pentru retrageri.",
  "最小输入*": "Minim {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Cantitatea minimă de retragere este *. Comisioanele de retragere vor fi deduse din suma retrasă. Verificați cu atenție adresa destinatarului. Nu trimiteți * la adrese din afara *. Nu utilizați adrese ICO sau de crowdfunding.",
  退出登录: "Deconectare",
  加仓: "Mărire poziție",
  新增仓位: "Poziție nouă",
  输入加仓金额: "Introduceți suma pentru mărirea poziției",
  "当前可用:": "Disponibil curent:",
  资产账单: "Factură active",
  保存二维码: "Salvează codul QR",
  温馨提示: "Notă",
  "请注意：您当前使用的网络": "Notă: Utilizați în prezent rețeaua",
  输入提现地址: "Introduceți adresa de retragere",
  "可用金额：": "Sumă disponibilă:",
  输入资产密码: "Introduceți parola activelor",
  可用手续费: "Comision disponibil",
  "折扣%": "Reducere %",
  实扣手续费: "Comision efectiv perceput",
  实际到账: "Sumă efectiv primită",
  未设置资产密码: "Parola activelor nu este setată",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Pentru siguranța dvs., setați o parolă a activelor înainte de a face retrageri.",
  热榜: "Populare",
  涨幅榜: "Cele mai mari creșteri",
  跌幅榜: "Cele mai mari scăderi",
  成交额榜: "Clasament volum",
  关于我们: "Despre noi",
  登录密码: "Parolă autentificare",
  设置: "Setări",
  资产密码: "Parolă active",
  修改登录密码: "Modificare parolă autentificare",
  原密码: "Parolă veche",
  请输入新密码: "Introduceți parola nouă",
  请输入原密码: "Introduceți parola veche",
  确认密码: "Confirmă parola",
  确定修改: "Confirmă modificarea",
  修改资产密码: "Modificare parolă active",
  验证码: "Cod de verificare",
  资产密码使用提示: "Sfaturi parolă active",
  "资产密码用于转移、提取资产和交易。":
    "Parola activelor este utilizată pentru transferul, retragerea și tranzacționarea activelor.",
  "创建与登录密码不同的资产密码。":
    "Creați o parolă a activelor diferită de parola de autentificare.",
  "定期更改您的资产密码。": "Schimbați-vă periodic parola activelor.",
  提币历史: "Istoric retrageri",
  "金额/余额": "Sumă/Sold",
  "手续费/折扣": "Comision/Reducere",
  自选: "Favorite",
  现货: "Spot",
  市价: "Preț de piață",
  止损设置: "Setări stop-loss",
  合约K线图: "Grafic futures",
  "24H量": "Volum 24h",
  "24H额": "Volum 24h (USDT)",
  合作指南: "Ghid partener",
  盈亏计算: "Calcul profit/pierdere",
  当前可用: "Disponibil curent",
  请输入加仓金额: "Introduceți suma pentru mărirea poziției",
  请重新输入加仓金额: "Introduceți din nou suma pentru mărirea poziției",
  平仓数量: "Cantitate de închis",
  欢迎登录: "Bine ați venit înapoi",
  "忘记密码?": "Ați uitat parola?",
  "还没有账号？": "Nu aveți încă un cont?",
  立即注册: "Înregistrați-vă acum",
  繁體中文: "Chineză tradițională",
  找回密码: "Recuperare parolă",
  下一步: "Următorul",
  注册账户: "Înregistrare cont",
  "请输入邀请码(选填)": "Introduceți codul de invitație (opțional)",
  谢邀豪礼: "Bonus de invitație",
  "24小时邀请好友排名": "Clasament invitații 24h",
  "*人": "* persoane",
  "差*人": "Mai lipsesc * persoane",
  "已超过10万人，每月轻松赚钱":
    "Peste 100.000 de utilizatori, câștigați bani ușor în fiecare lună",
  最高: "Maxim",
  邀请链接: "Link de invitație",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Împărțiți comisioanele de tranzacționare generate de prietenii dvs. (spot, futures, efect de levier, schimb rapid).",
  平台和您一起分享手续费:
    "Împărțiți comisioanele de tranzacționare cu platforma",
  "*级": "* nivel",
  规则: "Reguli",
  我的好友: "Prietenii mei",
  好友详情: "Detalii prieten",
  获得好友佣金方案: "Plan comision prieteni",
  我的等级: "Nivelul meu",
  我的邀请数据: "Datele mele de invitație",
  当前等级: "Nivel actual",
  平台奖励您: "Recompensa platformei pentru dvs.",
  最高可获取平台奖励: "Recompensa maximă a platformei",
  邀请规则: "Reguli de invitație",
  "邀请*级有效好友": "Invitați prieteni activi de nivel *",
  好友等级: "Nivel prieten",
  人: "persoane",
  奖金派送: "Plată bonus",
  平台奖励: "Recompensă platformă",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Platforma își rezervă dreptul de interpretare finală. În cazul unor activități frauduloase, recompensele vor fi anulate, iar contul dvs. va fi înghețat. Activele pierdute nu pot fi recuperate.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Contul dvs. trebuie să fie activ, definit ca o depunere în valoare de cel puțin * USDT în orice criptomonedă.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Prietenul invitat trebuie să fie un subordonat activ, definit ca o depunere în valoare de cel puțin * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Invitatorul și invitatul nu pot partaja aceeași adresă IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Nivelul VIP este determinat de numărul de prieteni invitați de nivel *.",
  佣金成分: "Componente comision",
  收益统计: "Statistici randament",
  昨日收益: "Randamentul de ieri",
  月收益: "Randament lunar",
  获取收益: "Obțineți randament",
  "总收益：": "Randament total:",
  "*级好友": "Prieteni de nivel *",
  理财购买: "Cumpărare produs financiar",
  期限: "Durată",
  可用金额: "Sumă disponibilă",
  预估收益: "Randament estimat",
  申购上限: "Cumpărare maximă",
  项目剩余: "Proiect rămas",
  "买入后预计*(SGT)开始计算收益。":
    "Randamentul va începe să fie calculat aproximativ la *(SGT) după cumpărare.",
  计息日: "Începutul calculului dobânzii",
  申购日: "Data cumpărării",
  到账日: "Data creditării",
  到期自动续投: "Reinvestire automată la expirare",
  申购: "Cumpără",
  搜索理财项目: "Căutați produs financiar",
  超高年化随心选: "Alegeți dintre produsele cu randament ridicat",
  "自由选择理财币种，稳定超额收益":
    "Alegeți liber criptomoneda pentru randamente stabile, peste medie",
  理财总资产: "Total active investite",
  申购数量: "Cantitate de cumpărat",
  立即购买: "Cumpără acum",
  年化收益率: "Randament procentual anual (APY)",
  理财订单: "Comenzi produse financiare",
  持有: "În deținere",
  申购份额: "Cotă cumpărată",
  到账日期: "Data creditării",
  申购成功: "Cumpărare reușită",
  到期: "Expirat",
  是否选择做多: "Deschideți poziție long?",
  "可用余额为0 不能操作": "Soldul este 0, acțiunea nu este posibilă",
  福利中心: "Centru bonusuri",
  奖励记录: "Istoric recompense",
  我获取到的奖励: "Recompensele mele obținute",
  总价值: "Valoare totală",
  新手任务: "Sarcini pentru utilizatori noi",
  身份认证: "Verificare identitate (KYC)",
  身份验证: "Verificare identitate",
  去验证: "Verifică acum",
  审核中: "În așteptare",
  已验证: "Verificat",
  认证失败: "Verificare eșuată",
  基础认证: "Verificare de bază",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Notă: Informațiile verificate nu pot fi modificate. Introduceți date corecte.",
  "国家/地区": "Țară/Regiune",
  请选择: "Selectați",
  证件类型: "Tip document",
  证件编码: "Număr document",
  身份证: "Carte de identitate",
  护照: "Pașaport",
  驾驶证: "Permis de conducere",
  请输入编码: "Introduceți numărul",
  名字: "Prenume",
  请输入: "Introduceți",
  中间名: "Al doilea prenume",
  选填: "Opțional",
  姓氏: "Nume de familie",
  中国: "China",
  身份上传: "Încărcați documentul de identitate",
  上传身份证: "Încărcați cartea de identitate",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Încărcați în format JPG/JPEG/PNG. Asigurați-vă că imaginile sunt clare, complete și uniform iluminate. Maxim *MB.",
  确定提交: "Trimite",
  去认证: "Verifică",
  挑战任务: "Sarcini provocare",
  注册认证任务: "Sarcina de înregistrare și verificare",
  完成注册认证即可领取:
    "Finalizați înregistrarea și verificarea pentru a primi",
  领取奖励: "Primește recompensa",
  新人豪礼: "Bonus de bun venit",
  "参与人数：": "Număr de participanți:",
  条件: "Condiție",
  入金量: "Suma depusă",
  完成: "Finalizat",
  任务奖励: "Recompensă sarcină",
  距任务更新: "Până la actualizarea sarcinii",
  "条件：": "Condiție:",
  活动规则: "Reguli activitate",
  奖励明细: "Detalii recompensă",
  已获得: "Obținut",
  交易奖励: "Recompensă tranzacționare",
  Win奖励: "Recompensă WIN",
  已领取: "Primit",
  亏损金额超过: "Suma pierderii depășește",
  单笔开仓金额超过: "Suma unui singur ordin depășește",
  交易量: "Volum tranzacționare",
  待完成: "În așteptare",
  入金: "Depunere",
  盈利金额超过: "Suma profitului depășește",
  开仓金额: "Sumă ordin",
  开仓金: "Sumă ordin",
  盈利: "Profit",
  亏损: "Pierdere",
  领取: "Primește",
  未领取: "Neprimit",
  待领取: "De primit",
  再交易: "Tranzacționați mai departe",
  即可获得: "pentru a primi",
  领取成功: "Primit cu succes",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Toate activitățile vor fi decontate la data de încheiere. Recompensele expiră după aceea.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Randamentul obținut va fi creditat în contul dvs. de recompense, pe care îl puteți schimba sau retrage oricând.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Criptomoneda recompensei depinde de sarcină.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Platforma își rezervă dreptul de interpretare finală. În caz de fraudă cu sarcinile, recompensele vor fi reținute, iar contul dvs. poate fi înghețat.",
  成长学院: "Academie",
  "区块链 & 加密货币": "Blockchain & Criptomonedă",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Ghidul dvs. complet pentru criptomonede. Vă însoțim în călătoria dvs. cripto.",
  "全仓合约定单的全部保证金。":
    "Marja totală pentru ordinele futures cu marjă încrucișată.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Sold + (profit/pierdere nerealizat - comisioane - dobânzi finanțare) = Valoare netă / Marja utilizată * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Profitul/pierderea nerealizat afectează direct 'marja disponibilă'. Dacă profitul/pierderea nerealizat crește, marja disponibilă crește și invers.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Sold - (Marja utilizată) + (profit/pierdere nerealizat - comisioane - dobânzi finanțare)",
  "注:可继续用于开仓的保证金。":
    "Notă: Marja disponibilă pentru deschiderea de noi poziții.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Sold + (profit/pierdere nerealizat - comisioane - dobânzi finanțare)",
  "注:当前的资金结余。": "Notă: Soldul curent.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Se referă la soldul total al contului de futures, inclusiv sumele înghețate.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Notă: Cu cât rata de risc este mai mare, cu atât riscul este mai mic și invers.",
  该功能尚未开发: "Această funcție este încă în dezvoltare",
  重置密码: "Resetare parolă",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Introduceți 8-20 de caractere, inclusiv litere, numere și caractere speciale",
  修改成功: "Modificare reușită",
  输入验证码: "Introduceți codul de verificare",
  输入密码: "Introduceți parola",
  详情说明: "Detalii",
  已售罄: "Stoc epuizat",
  剩余期限: "Durată rămasă",
  限期: "Durată",
  闪兑货币选择: "Selectare monedă pentru schimb rapid",
  地区选择: "Selectare regiune",
  "搜索国家/地区": "Căutați țară/regiune",
  "身份信息已提交，将在*小时内审核完成":
    "Informațiile de identitate au fost trimise. Procesarea va dura până la * ore.",
  "选择国家/地区": "Selectați țara/regiunea",
  "止盈价格需高于*": "Prețul take-profit trebuie să fie mai mare decât *",
  "止损价格需低于*": "Prețul stop-loss trebuie să fie mai mic decât *",
  "止盈价格需低于*": "Prețul take-profit trebuie să fie mai mic decât *",
  "止损价格需高于*": "Prețul stop-loss trebuie să fie mai mare decât *",
  教程详情: "Detalii tutorial",
  请输入止损价: "Introduceți prețul stop-loss",
  活期: "Flexibil",
  赎回后立即到账: "Creditare imediată după răscumpărare",
  赎回: "Răscumpărare",
  赎回理财: "Răscumpărare produs financiar",
  是否赎回当前的理财订单:
    "Răscumpărați comanda curentă a produsului financiar?",
  维护: "Mentenanță",
  "系统正在维护中……": "Sistemul este în mentenanță...",
  合约: "Futures",
  闪电兑换: "Schimb rapid",
  流水挖矿: "Mining volum",
  邀请豪礼: "Bonus invitație",
  计算器: "Calculator",
  最新价: "Ultimul preț",
  涨跌幅: "Modificare (24h)",
  关注币种添加自选: "Adăugați criptomoneda la favorite",
  一键添加自选: "Adăugați la favorite (un clic)",
  全标已读: "Marchează tot ca citit",
  无消息: "Niciun mesaj",
  "暂时还没有收到任何消息通知哦!": "Nu ați primit încă nicio notificare!",
  没有更多数据: "Nu există mai multe date",
  闪兑: "Schimb rapid",
  从: "De la",
  "可用余额：": "Sold disponibil:",
  至: "La",
  预览兑换结果: "Previzualizare rezultat schimb",
  闪兑规则: "Reguli schimb rapid",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Schimbul rapid este supus fluctuațiilor pieței. Suma efectiv primită este obligatorie.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Ratele de schimb sunt stabilite de terți. Din cauza costurilor și fluctuațiilor, rata poate diferi de rata pieței. Verificați cu atenție.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platforma percepe aproximativ *% comision per schimb pentru a acoperi costurile pe burse.",
  确认汇兑: "Confirmă schimbul",
  您预估得到: "Primire estimată",
  汇兑: "Schimb",
  汇兑比例: "Rată de schimb",
  刷新: "Reîmprospătează",
  兑换: "Schimbă",
  没有更多了: "Nu există mai multe date",
  搜索币种: "Căutați criptomoneda",
  可用: "Disponibil",
  我知道了: "Am înțeles",
  最新价格: "Ultimul preț",
  确认: "Confirmă",
  最大: "Maxim",
  "风险率(%)": "Rată de risc (%)",
  当前委托: "Ordine curente",
  合作交易历史记录: "Istoric tranzacții partener",
  重置: "Resetare",
  余额: "Sold",
  现货账户: "Cont spot",
  合约账户: "Cont futures",
  WIN账户: "Cont WIN",
  赏金账户: "Cont recompense",
  总资产折合: "Total active (în USDT)",
  今日收益: "Randamentul de azi",
  充币: "Depunere",
  提币: "Retragere",
  账户权益: "Valoarea contului",
  "数量/类别": "Cantitate/Categorie",
  全部币种: "Toate criptomonedele",
  全部类型: "Toate tipurile",
  账单信息: "Informații factură",
  理财赎回: "Răscumpărare produs financiar",
  购买理财: "Cumpărare produs financiar",
  收入: "Venituri",
  支出: "Cheltuieli",
  到: "către",
  资产划转: "Transfer active",
  "最少*": "Minim *",
  "可用资产：": "Active disponibile:",
  确认划转: "Confirmă transferul",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Trebuie să transferați activele în contul corect pentru a putea tranzacționa. Transferurile între conturi sunt gratuite.",
  币种账户选择: "Selectare cont criptomonedă",
  选择账户: "Selectați contul",
  划转详情: "Detalii transfer",
  划转明细: "Specificații transfer",
  收入账单: "Factură venituri",
  支出账单: "Factură cheltuieli",
  金额: "Sumă",
  总收益: "Randament total",
  佣金: "Comision",
  用户名: "Nume utilizator",
  "已领取：": "Primit:",
  "未领取：": "Neprimit:",
  "请选择国家/地区": "Selectați țara/regiunea",
  请上传身份信息: "Încărcați informațiile de identitate",
  请选择证件类型: "Selectați tipul de document",
  请填写证件编码: "Introduceți numărul documentului",
  请填写名字: "Introduceți prenumele",
  请填写姓氏: "Introduceți numele de familie",
  投资金额: "Sumă investiție",
  天: "zile",
  请输入手机号: "Introduceți numărul de telefon",
  搜索: "Căutare",
  搜索历史: "Istoric căutări",
  热门推荐: "Recomandări populare",
  "《Xspace Earn协议》": "Protocolul Xspace Earn",
  我已了解并同意: "Am înțeles și sunt de acord",
  协议: "Protocol",
  Xspace官方中文交流群: "Comunitatea oficială chineză Xspace",
  Xspace官方英文交流群: "Comunitatea oficială engleză Xspace",
  预计维护至: "Mentenanță estimată până la",
  更多功能: "Mai multe funcții",
  下载APP: "Descărcați aplicația",
  理财: "Produs financiar",
  推荐: "Recomandat",
  Telegram官方中文频道: "Canal oficial Telegram (chineză)",
  Telegram官方英文频道: "Canal oficial Telegram (engleză)",
  官方邮箱: "E-mail oficial",
  客服邮箱: "E-mail serviciu clienți",
  上述信息最终解释权归官方所有:
    "Informațiile de mai sus sunt supuse interpretării oficiale a platformei.",
  IOS版下载: "Descărcare pentru iOS",
  Android版下载: "Descărcare pentru Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Comision tranzacție = Comision cumpărare + Rată finanțare + Comision vânzare",
  资金划转: "Transfer fonduri",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Închidere automată",
  委托挂单: "Ordin deschis",
  买: "Cumpără",
  卖: "Vinde",
  "买入/做多": "Cumpără/Long",
  "卖出/做空": "Vinde/Short",
  详情: "Detalii",
  浮动涨跌: "Profit/pierdere nerealizat",
  最小: "Minim",
  充币数量: "Cantitate depunere",
  请输入充币数量: "Introduceți cantitatea de depunere",
  支付截图: "Dovadă plată",
  提交: "Trimite",
  上传驾驶证: "Încărcați permisul de conducere",
  上传护照: "Încărcați pașaportul",
  加载中: "Se încarcă...",
  上传成功: "Încărcare reușită",
  充值历史: "Istoric depuneri",
  合约卖出手续费: "Comision vânzare futures",
  合约买入手续费: "Comision cumpărare futures",
  系统加款: "Creditare sistem",
  系统减款: "Debitare sistem",
  合约资金费率: "Rată finanțare futures",
  佣金分成: "Împărțire comision",
  U本位合约: "Futures cu marjă în USDT",
  资产管理: "Gestionare active",
  APP下载: "Descărcați aplicația",
  全球领先的数字理财平台:
    "Platforma lider mondial de gestionare a averii digitale",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Tranzacționați imediat Bitcoin, Ethereum și sute de alte active digitale",
  "24H涨跌幅": "Modificare 24h",
  查看更多行情: "Vedeți mai multe piețe",
  近24小时成交量: "Volum 24h",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Oferă sute de perechi spot și futures. Peste 20 de milioane de utilizatori în peste 200 de țări. O platformă lider mondial de servicii pentru active digitale.",
  用户国家分布: "Utilizatori pe țări",
  用户数: "Număr utilizatori",
  交易对: "Perechi de tranzacționare",
  服务支持: "Asistență",
  "随时随地，多平台终端交易":
    "Tranzacționați oriunde cu suport multi-platformă",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Compatibil cu mai multe dispozitive pentru toate nevoile de tranzacționare.",
  随时查看实时行情: "Vedeți prețurile în timp real oriunde",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Cumpărați și vindeți cu ușurință BTC, ETH, DOGE și alte active digitale",
  获取您关注的加密货币价格变化预警:
    "Primiți alerte de preț pentru criptomonedele urmărite",
  "查看比特币现货、期货、期权价格":
    "Vedeți prețurile spot, futures și opțiuni Bitcoin",
  比较各交易所加密货币价格: "Comparați prețurile criptomonedelor pe burse",
  开启您的数字货币之旅: "Începeți călătoria dvs. cu activele digitale",
  快捷购买数字货币: "Cumpărați rapid criptomonede",
  "使用多种支付方式交易数字货币，安全快捷":
    "Tranzacționați în siguranță și rapid cu mai multe metode de plată",
  最优的交易费率: "Cele mai bune comisioane de tranzacționare",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tarife avantajoase, beneficii VIP competitive și servicii de cea mai bună calitate.",
  可信赖的安全保障: "Siguranță de încredere",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Măsurile avansate de securitate și fondul SAFU vă protejează activele împotriva riscurilor.",
  交易: "Tranzacționare",
  币币市场: "Piața spot",
  "24H成交量": "Volum 24h",
  交易所: "Bursă",
  "24H最高": "Maxim 24h",
  "24H最低": "Minim 24h",
  永续合约: "Futures perpetue",
  日涨跌: "Modificare zilnică",
  交易深度: "Adâncimea cărții de ordine",
  "资产(合约)": "Active (Futures)",
  历史仓位: "Istoric poziții",
  兑换记录: "Istoric schimburi",
  类型: "Tip",
  充值记录: "Istoric depuneri",
  划转记录: "Istoric transferuri",
  类别: "Categorie",
  历史账单: "Istoric facturi",
  在线充值: "Depunere online",
  安全设置: "Setări de securitate",
  用于账户登录使用: "Utilizat pentru autentificarea în cont",
  用户提现时安全验证使用:
    "Utilizat pentru verificarea securității la retrageri",
  验证: "Verifică",
  万: "milion",
  随时随地开启交易: "Începeți tranzacționarea oriunde",
  "*货币交易所的所有功能尽在你的手中。":
    "Toate funcțiile bursei de criptomonede * în mâna dvs.",
  "下载*货币交易所APP。": "Descărcați aplicația bursei de criptomonede *.",
  下载自: "Descărcați de pe",
  内测版: "Versiune beta",
  下载: "Descărcare",
  扫码下载: "Scanați pentru a descărca",
  设置您的资产密码: "Setați-vă parola activelor",
  法币: "Fiat",
  我要买: "Vreau să cumpăr",
  我要卖: "Vreau să vând",
  请输入金额: "Introduceți suma",
  汇率: "Rată de schimb",
  获得: "Primiți",
  支付通道: "Canal de plată",
  收款通道: "Canal de primire",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Asigurați-vă că canalul de primire este pe numele dvs. atunci când vindeți.",
  当前法币暂不支持交易对可尝试前往提现:
    "Această pereche fiat nu este acceptată momentan. Încercați o retragere.",
  前往提现: "Mergi la retragere",
  该法币暂无通道: "Niciun canal disponibil pentru această monedă fiat",
  "正在出售中，请耐心等待": "Vânzarea este în curs, vă rugăm să așteptați",
  请选择支付通道: "Selectați canalul de plată",
  请选择方式: "Selectați metoda",
  法币历史: "Istoric fiat",
  买币: "Cumpără criptomonedă",
  卖币: "Vinde criptomonedă",
  失败: "Eșuat",
  已完成: "Finalizat",
  未付款: "Neplătit",
  待审核: "În așteptare",
  打款中: "Plată în curs",
  订单详情: "Detalii comandă",
  联系客服: "Contactați serviciul clienți",
  到账金额: "Sumă primită",
  通道: "Canal",
  收款人: "Beneficiar",
  收款账户: "Cont beneficiar",
  "订单出售失败，请查下方失败原因":
    "Vânzarea comenzii a eșuat. Vedeți motivul mai jos.",
  失败原因: "Motivul eșecului",
  您还未进行付款: "Nu ați plătit încă",
  您已成功购买: "Cumpărarea a fost reușită",
  已取消订单: "Comandă anulată",
  "订单正在审核中，请耐心等待":
    "Comanda este în curs de procesare. Vă rugăm să așteptați.",
  您已成功出售: "Vânzarea a fost reușită",
  "订单正在打款中，请耐心等待": "Plata este în curs. Vă rugăm să așteptați.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Pentru plată, trebuie să vizitați o altă platformă. Fiți atenți la securitatea informațiilor dvs.",
  当前法币暂不支持交易对可尝试前往充值:
    "Această pereche fiat nu este acceptată momentan. Încercați o depunere.",
  前往充值: "Mergi la depunere",
  购买: "Cumpără",
  订单号: "Număr comandă",
  单价: "Preț unitar",
  到账数量: "Cantitate primită",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Există o comandă neplătită. Doriți să inițiați o nouă comandă de plată?",
  继续支付: "Continuă plata",
  重新下单: "Comandă nouă",
  是否确定出售: "Sigur doriți să vindeți?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "După confirmare, platforma va atribui un cumpărător. Așteptați potrivirea.",
  出售: "Vinde",
  收款方式: "Metodă de primire",
  订单已生成: "Comandă generată",
  取消订单: "Anulează comanda",
  请在: "Vă rugăm în",
  内完成付款: "finalizați plata",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Părăsiți platforma, autentificați-vă în metoda de plată aleasă și transferați suma în următorul cont al vânzătorului. Specificați întotdeauna referința:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Fără referință, vânzătorul nu poate confirma plata, ceea ce poate duce la pierderea activelor.",
  "未在规定的时间内付款，订单都将被取消。":
    "Dacă nu plătiți în timpul specificat, comanda va fi anulată.",
  姓名: "Nume",
  收款姓名: "Numele beneficiarului",
  开户支行: "Sucursala băncii",
  银行卡号: "Numărul cardului bancar",
  "付款后，返回本平台": "După plată, reveniți pe această platformă",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Apăsați butonul 'Am finalizat plata, anunță vânzătorul'",
  未点击卖家不会放款:
    "Vânzătorul va elibera criptomoneda numai după ce apăsați butonul",
  交易条款: "Termeni tranzacție",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Fondurile pentru cumpărare trebuie să fie legale și sigure",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Frauda, schemele piramidale, jocurile de noroc sau alte fonduri ilegale nu sunt permise",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Dacă fondurile sunt înghețate sau suspecte după tranzacție, nu vom elibera USDT și vom oferi o rambursare",
  "已付款，通知卖家": "Plătit, anunță vânzătorul",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Dacă anulați în total * comenzi astăzi, dreptul dvs. de cumpărare pentru ziua respectivă va fi anulat. Anulați această comandă?",
  添加收款方式: "Adăugați metodă de primire",
  是否删除此收款方式: "Ștergeți această metodă de primire?",
  删除: "Șterge",
  请选择法币: "Selectați moneda fiat",
  机构名称: "Numele instituției",
  请选择机构: "Selectați instituția",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Metoda de primire aleasă va fi afișată cumpărătorilor atunci când vindeți criptomonede. Asigurați-vă că datele sunt corecte.",
  请选择银行: "Selectați banca",
  请输入姓名: "Introduceți numele",
  账号: "Număr cont",
  请输入账号: "Introduceți numărul contului",
  收款码: "Cod de primire",
  "银行账号/卡号": "Cont bancar/Număr card",
  "请输入银行账号/卡号": "Introduceți contul bancar/numărul cardului",
  "开户支行（选填）": "Sucursala băncii (opțional)",
  请输入开户支行: "Introduceți sucursala băncii",
  "加入*官方频道": "Alăturați-vă canalului oficial *",
  关于: "Despre",
  条款: "Termeni",
  成功: "Succes",
  等待: "Așteptare",
  作废: "Nul",
  确认付款: "Confirmă plata",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Plată finalizată? După confirmare, vânzătorul va confirma primirea în * minute.",
  最大金额: "Sumă maximă",
  最小金额: "Sumă minimă",
  付款: "Plătește",
  法币充值: "Depunere fiat",
  法币提现: "Retragere fiat",
  待支付: "De plătit",
  已支付: "Plătit",
  商户名: "Numele vânzătorului",
  当前没有添加支付方式: "Nicio metodă de plată adăugată",
  添加后再出售: "Adăugați una înainte de a vinde",
  新人大礼包: "Pachet de bun venit",
  注册即可领取: "Primiți după înregistrare",
  立即领取: "Primește acum",
  不再提示: "Nu mai afișa",
  "该奖励需在APP中领取，请下载APP":
    "Această recompensă poate fi primită doar în aplicație. Descărcați aplicația.",
  去交易: "Mergi la tranzacționare",
  期权交易: "Tranzacționare opțiuni",
  交易额: "Sumă tranzacționată",
  可用额度: "Limită disponibilă",
  交易周期: "Perioadă tranzacționare",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Short",
  当前持有: "Poziția curentă",
  胜率: "Rată de succes",
  "盈利/亏损数": "Numărul tranzacțiilor cu profit/pierdere",
  累计实现盈亏: "Profit/pierdere total realizat",
  秒: "secunde",
  分: "minute",
  小时: "ore",
  周: "săptămână",
  下单时间: "Timp comandă",
  剩余时间: "Timp rămas",
  买入价: "Preț de cumpărare",
  结算价: "Preț de decontare",
  实现盈利: "Profit realizat",
  结算时间: "Timp decontare",
  期权: "Opțiune",
  新手教程: "Ghid pentru începători",
  我的订单: "Comenzile mele",
  赔率: "Cote",
  全部订单: "Toate comenzile",
  持有订单: "Comenzi deschise",
  历史订单: "Istoric comenzi",
  输入交易额度: "Introduceți suma de tranzacționare",
  选择交易周期: "Selectați perioada de tranzacționare",
  去注册: "Înregistrare",
  冻结: "Îngheață",
  期权支出: "Cheltuială opțiune",
  期权收入: "Venit opțiune",
  用户提现: "Retragere utilizator",
  "是否购买？": "Cumpărați această opțiune?",
  购买成功: "Cumpărare reușită",
  请签名: "Vă rugăm să semnați",
  提交签名: "Trimiteți semnătura",
  清空签名: "Goliți semnătura",
  签名审核中: "Semnătura în curs de verificare",
  已提交: "Trimis",
  扫一扫下载APP: "Scanați pentru a descărca aplicația",
  新手领取大礼包: "Pachet de bun venit pentru utilizatori noi",
  注册实名即送彩金: "Înregistrați-vă și verificați-vă pentru a primi un bonus",
  交易总额: "Volum total tranzacționare",
  资产不足: "Active insuficiente",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Active insuficiente în contul WIN. Puteți transfera active din contul dvs. principal.",
  Win: "WIN",
  比赛: "Competiție",
  未开始: "Neînceput",
  赛程: "Program",
  赛果: "Rezultat",
  已结束: "Încheiat",
  让球: "Handicap",
  进球数: "Goluri",
  大: "Peste",
  小: "Sub",
  胜负平: "1X2 (Victorie/Egal/Înfrângere)",
  和局: "Egal",
  投注: "Pariu",
  下注金额: "Sumă pariată",
  下注: "Pariu",
  阵容: "Echipă",
  分析: "Analiză",
  输入下注金额: "Introduceți suma pariată",
  下注成功: "Pariu plasat cu succes",
  投注记录: "Istoric pariuri",
  未结算: "Nedecontat",
  已结算: "Decontat",
  流水: "Volum",
  输赢: "Câștig/Pierdere",
  赛时: "Timp meci",
  下注时间: "Timp pariu",
  足彩竞猜: "Pronostic fotbal",
  查看详情: "Vezi detalii",
  输: "Pierdere",
  赢: "Câștig",
  主: "Acasă",
  客: "Deplasare",
  主胜: "Victorie acasă",
  客胜: "Victorie deplasare",
  平: "Egal",
  已延期: "Amânat",
  账号异常: "Anomalie cont",
  全场独赢: "Tot meciul 1X2",
  全场让球: "Tot meciul Handicap",
  全场大小: "Tot meciul Peste/Sub",
  总进球: "Total goluri",
  拍摄照片要求: "Cerințe fotografie",
  标准拍摄: "Fotografie standard",
  边框缺失: "Margine lipsă",
  照片模糊: "Fotografie neclară",
  闪光强烈: "Flaș prea puternic",
  上传手持证件照: "Încărcați fotografia cu documentul în mână",
  上传证件照: "Încărcați fotografia documentului",
  换一张: "Fotografie nouă",
  出生日期: "Data nașterii",
  请选择出生日期: "Selectați data nașterii",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Introduceți codul de verificare de mai jos pentru a obține un cod prin e-mail pentru înregistrare.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Mai aveți * încercări de verificare. După această limită, nu vă veți mai putea verifica.",
  上半场: "Prima repriză",
  下半场: "Repriza a doua",
  独赢: "1X2",
  上半场独赢: "Prima repriză 1X2",
  下半场独赢: "Repriza a doua 1X2",
  上半场让球: "Prima repriză Handicap",
  下半场让球: "Repriza a doua Handicap",
  上半场大小球: "Prima repriză Peste/Sub",
  下半场大小球: "Repriza a doua Peste/Sub",
  波胆: "Scor exact",
  上半场波胆: "Prima repriză Scor exact",
  下半场波胆: "Repriza a doua Scor exact",
  单双: "Impar/Par",
  单: "Impar",
  双: "Par",
  上半场单双: "Prima repriză Impar/Par",
  下半场单双: "Repriza a doua Impar/Par",
  上半场总进球: "Prima repriză Total goluri",
  下半场总进球: "Repriza a doua Total goluri",
  中场: "Pauză",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Notă: Pentru fotografia cu documentul în mână, scrieți textul pe o foaie de hârtie albă și fotografiați-l împreună cu documentul dvs., ca în exemplu.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Recent, multe conturi frauduloase au fost pedepsite. Contactați serviciul clienți dacă credeți că contul dvs. a fost pedepsit pe nedrept.",
  最小下注金额: "Pariu minim",
  参与活动最小下注金额: "Pariu minim pentru a participa la activitate",
  记住密码: "Ține-mă minte",
  比分: "Scor",
  "您还未登录，请先登录":
    "Nu sunteți autentificat. Autentificați-vă mai întâi.",
  立即登录: "Autentificare acum",
  下注限额: "Limită pariu",
  可赢金额: "Sumă câștigabilă",
  闪兑详情: "Detalii schimb rapid",
  大小球: "Peste/Sub",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Din cauza fluctuațiilor cursului de schimb, suma finală a pariului poate diferi. Comanda este obligatorie.",
  开赛时间: "Ora de începere",
  足球收入: "Venituri fotbal",
  足球支出: "Cheltuieli fotbal",
  活动详情: "Detalii activitate",
  为世界杯喝彩: "Susțineți Campionatul Mondial",
  我的竞猜: "Pronosticurile mele",
  "竞猜比赛、有机会瓜分*USDT":
    "Pronosticați meciuri și câștigați o parte din * USDT",
  "瓜分*USDT": "Împărțiți * USDT",
  距离活动结束还有: "Până la sfârșitul activității:",
  我的门票: "Biletele mele",
  竞猜结束时间: "Sfârșitul pronosticurilor",
  猜比分: "Pronosticați scorul",
  "福利派送中，完成任务即可获取门票":
    "Bonusurile sunt distribuite. Finalizați sarcinile pentru a câștiga bilete.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Finalizați următoarele sarcini pentru a obține numărul corespunzător de bilete pentru a participa la competiție.",
  时: "oră",
  活动: "Activitate",
  竞猜记录: "Istoric pronosticuri",
  结果: "Rezultat",
  任务: "Sarcină",
  去邀请: "Invită",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Pronosticați scorul fiecărui meci și câștigați o parte din $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Pentru a pronostica aveți nevoie de un bilet. Biletele pot fi câștigate prin finalizarea sarcinilor platformei.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "După un pronostic reușit, trimiteți o captură de ecran serviciului clienți. Aceștia vor credita bonusul în contul dvs., pe care îl puteți retrage imediat.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Frauda este interzisă. Dacă este descoperită, recompensa va fi anulată.",
  "完成任务后，点击咨询客服获得门票。":
    "După finalizarea sarcinilor, faceți clic pe 'Contactați serviciul clienți' pentru a primi bilete.",
  继续猜: "Continuați pronosticul",
  总单数: "Numărul total de pariuri",
  赛事筛选: "Filtrare după eveniment",
  球队筛选: "Filtrare după echipă",
  总金额: "Sumă totală",
  总流水: "Volum total",
  派奖金额: "Sumă bonus acordată",
  下注单数: "Numărul de pariuri",
  利润: "Profit",
  更多福利: "Mai multe bonusuri",
  我的奖金: "Bonusul meu",
  未认证: "Neverificat",
  总量: "Total",
  或: "sau",
  模拟交易: "Tranzacționare demo",
  体验账户不可操作: "Indisponibil pe contul demo",
  世界杯比分竞猜: "Pronostic scor CM",
  "领*USDT起": "Primiți de la * USDT",
  消息: "Mesaje",
  滚球: "Pariuri live",
  是: "Da",
  不是: "Nu",
  当前余额: "Sold curent",
  KOL招募: "Recrutare KOL",
  本月净输赢: "Profit/pierdere net în această lună",
  本月佣金: "Comision în această lună",
  佣金比例: "Procent comision",
  活跃人数: "Utilizatori activi",
  新增下级: "Subordonați noi",
  登录人数: "Utilizatori autentificați",
  首存人数: "Utilizatori cu prima depunere",
  数据分析: "Analiză date",
  人数: "Număr persoane",
  新注册存款金额: "Suma depusă de noile înregistrări",
  老用户存款金额: "Suma depusă de utilizatorii existenți",
  首存金额: "Suma primei depuneri",
  快捷入口: "Acces rapid",
  成员管理: "Gestionare membri",
  财务报表: "Rapoarte financiare",
  分红报表: "Raport dividende",
  订单记录: "Istoric comenzi",
  VIP专享: "Exclusiv VIP",
  推广工具: "Instrumente de promovare",
  计算规则: "Reguli de calcul",
  账变明细: "Detalii tranzacție",
  成员: "Membri",
  下级概览: "Prezentare generală subordonați",
  下级成员总计: "Total subordonați",
  本月新增: "Noi în această lună",
  本月活跃会员: "Membri activi în această lună",
  今日活跃会员: "Membri activi astăzi",
  本月有效活跃: "Activi efectiv în această lună",
  活跃成员占比: "Procent membri activi",
  本月活跃: "Activi în această lună",
  今日活跃: "Activi astăzi",
  下级成员: "Subordonați",
  会员账号: "Cont membru",
  统计时间: "Timp statistică",
  筛选: "Filtrare",
  存款: "Depunere",
  取款: "Retragere",
  总输赢: "Total câștig/pierdere",
  是否有效用户: "Utilizator activ?",
  最近登录时间: "Ultima autentificare",
  否: "Nu",
  开始时间: "Ora de început",
  结束时间: "Ora de sfârșit",
  提取: "Retragere",
  总盈亏: "Rezultat total",
  净盈亏: "Rezultat net",
  分红: "Dividendă",
  概览: "Prezentare generală",
  月度详细数据: "Date lunare detaliate",
  未发放: "Neacordat",
  活跃用户: "Utilizatori activi",
  有效新增会员: "Membri noi efectivi",
  冲正后净输赢: "Profit/pierdere net după corecție",
  上月结余: "Sold luna trecută",
  净输赢: "Profit/pierdere net",
  "系统每日新加坡时间1:00更新一次报表":
    "Rapoartele sunt actualizate zilnic la ora 01:00, ora Singapore.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "În rapoarte, numerele pozitive înseamnă profit pentru partener, numerele negative înseamnă pierdere pentru partener.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Datele comisionului sunt actualizate zilnic, sunt orientative și nu constituie o bază definitivă de plată.",
  选择时间: "Selectați timpul",
  足球: "Fotbal",
  投注金额: "Sumă pariată",
  有效订单: "Comenzi valide",
  下级账户: "Cont subordonat",
  待成交: "În așteptare",
  下单金额: "Sumă comandă",
  订单内容: "Conținut comandă",
  秒数: "Secunde",
  联赛: "Ligă",
  队伍: "Echipă",
  比赛时间: "Ora meciului",
  玩法: "Tip pariu",
  等级规则表: "Tabel reguli nivel",
  等级: "Nivel",
  活跃会员: "Membri activi",
  最新活跃: "Ultima activitate",
  额外佣金: "Comision suplimentar",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Lunar pe baza standardelor de creștere. Puteți beneficia doar de un singur nivel.",
  渠道生成: "Generare canal",
  创建: "Creează",
  渠道名称: "Nume canal",
  注册人数: "Număr înregistrări",
  浏览人数: "Număr vizualizări",
  构建状态: "Stare construcție",
  禁用: "Dezactivează",
  启用: "Activează",
  查看: "Vezi",
  创建渠道: "Creează canal",
  创建成功: "Creare reușită",
  操作成功: "Operațiune reușită",
  渠道详情: "Detalii canal",
  邀请码: "Cod de invitație",
  访问人数: "Număr vizitatori",
  渠道地址: "Adresă canal",
  我的福利: "Bonusurile mele",
  充值福利: "Bonus depunere",
  当前流水: "Volum curent",
  如何参与: "Cum să participați",
  币种充值: "Depunere criptomonedă",
  充值福利中领取福利: "Primiți bonus la bonusul de depunere",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regulă: Bonusul de depunere este voluntar, valabil 24 de ore după depunere. După primire, retragerea va fi blocată temporar până când este atinsă cerința de volum.",
  失效日期: "Data expirării",
  "暂无福利领取，充值后领取": "Niciun bonus disponibil. Primiți după depunere.",
  参与: "Participă",
  充值赠送: "Bonus depunere",
  "领取*%的赠送": "Primiți *% bonus",
  去领取: "Primește",
  VIP奖励: "Recompensă VIP",
  "当前可领取*USDT，是否确认领取":
    "* USDT disponibil pentru primire. Confirmați?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "După primire, retragerea va fi blocată temporar până când se atinge un volum de * USDT.",
  充值送大礼: "Cadou depunere",
  "存入越多，送越多！":
    "Cu cât depuneți mai mult, cu atât cadoul este mai mare!",
  无效: "Nul",
  有效: "Valid",
  总存金额: "Sumă totală depusă",
  提示: "Notă",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Numerele pozitive în totalul și netul câștig/pierdere înseamnă profitul platformei. Datele zilnice sunt orientative.",
  "净盈亏：总盈亏-用户返水":
    "Rezultat net: Rezultat total - Rambursare utilizator",
  盈利方: "Partea cu profit",
  代理: "Agent",
  客户: "Client",
  平局: "Egal",
  平台: "Platformă",
  "已提交审核，请耐心等待": "Trimis pentru verificare. Vă rugăm să așteptați.",
  充值日期: "Data depunerii",
  平台本月总输赢: "Total câștig/pierdere platformă în această lună",
  KOL招募合作: "Colaborare recrutare KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platforma deschide recrutarea KOL. Cu un cont de social media, vă puteți bucura de dividende și venituri pe viață prin atragerea unică de clienți.",
  级别: "Nivel",
  平台利润返佣: "Comision profit platformă",
  佣金案例: "Exemplu comision",
  交易项目: "Produse de tranzacționare",
  "期权交易、合约交易、足球游戏":
    "Tranzacționare opțiuni, tranzacționare futures, jocuri fotbal",
  报名方式: "Metodă de înscriere",
  点击KOL招募报名: "Faceți clic pentru a vă înscrie la recrutarea KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Bun venit în echipa noastră. Vă sprijinim în construirea propriului sistem de utilizatori. Câștigați până la *% comision. Așteptăm cu nerăbdare participarea dvs.",
  输入联系方式: "Introduceți datele de contact",
  最低活跃人数: "Numărul minim de utilizatori activi",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "De exemplu: Dacă utilizatorii activi în această lună ≥ * și totalul câștig/pierdere al platformei ≥ * USDT, aparțineți nivelului * și primiți *% comision.",
  比分竞猜: "Pronostic scor",
  豪礼相赠: "Cadou mare",
  足球活动: "Activitate fotbal",
  圣诞节活动: "Activitate Crăciun",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Ați participat la o activitate. Retragerea este blocată temporar. Mai aveți nevoie de * USDT volum pentru a debloca.",
  剩余流水: "Volum rămas",
  助力足球: "Susține fotbalul",
  佣金累计: "Comision total",
  有效投注: "Pariuri valide",
  今日: "Astăzi",
  今日返水: "Rambursare astăzi",
  VIP返水: "Rambursare VIP",
  返水记录: "Istoric rambursări",
  成员信息: "Informații membru",
  基本信息: "Informații de bază",
  钱包余额: "Sold portofel",
  投注信息: "Informații pariu",
  返水: "Rambursare",
  总下注: "Total pariat",
  今日输赢: "Câștig/pierdere astăzi",
  下注动态: "Activitate pariuri",
  返水奖励: "Recompensă rambursare",
  分红金额: "Sumă dividendă",
  返水支出: "Cheltuială rambursare",
  总返水: "Total rambursare",
  流水总额: "Volum total",
  返水总额: "Total rambursare",
  返水详情: "Detalii rambursare",
  日流水: "Volum zilnic",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platforma oferă rambursare suplimentară pe baza volumului zilnic al subordonaților dvs. Plata zilnic la ora 00:00, ora Singapore, în contul de recompense.",
  "申请成功，等待审核": "Cerere reușită, în așteptarea verificării",
  "我出本金，盈利共分享": "Eu ofer capitalul, profitul este împărțit",
  最高分红: "Dividendă maximă",
  投资大师比赛: "Concursul Maestrul Investitor",
  "我出本金，你盈利": "Eu ofer capitalul, tu câștigi",
  共分享: "Împărțiți împreună",
  最高分红可得: "Dividendă maximă posibilă",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Bonus exclusiv de bun venit: $* gratuit. După primire, puteți investi în orice proiect. Profitul poate fi retras imediat.",
  报名领取: "Înscrieți-vă și primiți",
  审核驳回: "Verificare respinsă",
  驳回原因: "Motivul respingerii",
  活动运行周期: "Perioada de desfășurare a activității",
  "申请成功后起至*天内完成超额收益。":
    "Obțineți randament excedentar în * zile de la aprobare.",
  分红比: "Raport dividendă",
  "*日获得盈利后，可获得*%的收益额。":
    "După obținerea profitului în ziua *, primiți *% din suma randamentului.",
  参与条件: "Condiții de participare",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Utilizatori din Rusia sau Turcia care nu au participat încă.",
  计算项目: "Produse calculate",
  "合约、体育、期权": "Futures, Sport, Opțiuni",
  我的投资: "Investițiile mele",
  参与天数: "Zile de participare",
  累计下注: "Total pariat",
  累计盈亏: "Total câștig/pierdere",
  预计可分红: "Dividendă așteptată",
  常见问题: "Întrebări frecvente (FAQ)",
  什么是平台出资: "Ce este finanțarea platformei?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Platforma oferă fonduri gratuite utilizatorilor din anumite țări pentru a investi în proiecte.",
  怎么获取平台出资的福利: "Cum pot obține bonusul de finanțare al platformei?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Dacă sunteți dintr-una dintre țările desemnate, faceți clic pe butonul de înscriere. După aprobare, * USDT vor fi transferați în contul dvs. de recompense, pe care îl puteți transfera pentru a investi.",
  什么是分红: "Ce este dividendul?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividendă: Dacă randamentul atinge 100% în timpul specificat, primiți 50% din randamentul excedentar. Exemplu: Primiți 100 USDT, obțineți 120% randament, atunci 20% este excedentar.",
  "如何取得分红？": "Cum obțin dividendul?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Ciclul activității este o dată la * zile. După încheiere, se face decontarea. Dacă îndepliniți cerințele, dividendul este trimis în contul de recompense. Dacă nu, randamentul dvs. și finanțarea platformei vor fi eliminate.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Conturile participante trebuie să fie verificate KYC. Doar un bonus per cont.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC pentru participare este valabil doar pentru țările desemnate. Verificați dacă țara dvs. se potrivește cu țara activității.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "După participarea cu succes, retragerea va fi blocată temporar până la finalizarea activității.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Respectați regulile activității. În caz de fraudă sau abuz de erori de sistem, toate fondurile din contul dvs. vor fi înghețate permanent.",
  平台出资: "Finanțare platformă",
  平台出资收回: "Finanțare platformă retrasă",
  投资大师奖励: "Recompensă Maestrul Investitor",
  请下载APP添加收款方式:
    "Descărcați aplicația pentru a adăuga o metodă de primire",
  请下载APP进行身份验证:
    "Descărcați aplicația pentru a efectua verificarea identității",
  请下载APP参与: "Descărcați aplicația pentru a participa",
  技术指标: "Indicatori tehnici",
  主图: "Grafic principal",
  副图: "Grafic secundar",
  新注册人数: "Noi înregistrări",
  老用户存款人数: "Utilizatori existenți care depun",
  存款人数: "Numărul depunerilor",
  取款人数: "Numărul retragerilor",
  投注人数: "Numărul pariurilor",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Excluzând utilizatorii din Indonezia, India, Bangladesh care nu au participat încă.",
  市场动态: "Dinamica pieței",
  外汇合约: "Futures valutare",
  盈亏比: "Raport câștig/pierdere",
  委托价: "Preț ordin",
  可用余额: "Sold disponibil",
  持仓额: "Valoarea poziției",
  强平价: "Preț de lichidare",
  修改: "Modifică",
  修改价位: "Modifică prețul",
  外汇: "Forex",
  外汇账户: "Cont Forex",
  我的交易: "Tranzacțiile mele",
  未设置: "Nesetat",
  超出最大可设数值: "Depășește valoarea maximă setabilă",
  超出最小可设数值: "Sub valoarea minimă setabilă",
  止盈超出最小可设数值: "Take-profit sub valoarea minimă setabilă",
  止损超出最大可设数值: "Stop-loss depășește valoarea maximă setabilă",
  止盈超出最大可设数值: "Take-profit depășește valoarea maximă setabilă",
  止损超出最小可设数值: "Stop-loss sub valoarea minimă setabilă",
  挖矿: "Mining",
  交易账户: "Cont de tranzacționare",
  买涨: "Cumpără (Long)",
  买跌: "Vinde (Short)",
  请输入正确的银行卡信息:
    "Introduceți informațiile corecte ale cardului bancar",
  联系在线客服: "Contactați serviciul clienți live",
  法币交易请联系在线客服:
    "Contactați serviciul clienți pentru tranzacționarea fiat",
  提交订单: "Trimite comanda",
  "支付过程如有疑问,请联系在线客服":
    "Contactați serviciul clienți dacă aveți întrebări despre procesul de plată",
  彩金赠送: "Acordare bonus",
  在线客服: "Chat live",
  最少投资: "Investiție minimă",
  "提交时间:": "Timpul trimiterii:",
  提现拒绝: "Retragere respinsă",
  认证拒绝: "Verificare respinsă",
  认证通过: "Verificare aprobată",
  请输入正确的交易额度: "Introduceți o sumă de tranzacționare validă",
  最大下注金额: "Pariu maxim",
  手机号: "Număr de telefon",
  邮箱注册: "Înregistrare cu e-mail",
  手机号注册: "Înregistrare cu număr de telefon",
  查询: "Interogare",
  手机号登录: "Autentificare cu număr de telefon",
  邮箱登录: "Autentificare cu e-mail",
  请输入数量: "Introduceți cantitatea",
  可用数量: "Cantitate disponibilă",
  钱包登录: "Autentificare cu portofel",
  请输入正确的邀请码: "Introduceți un cod de invitație valid",
  "请输入邀请码(必填)": "Introduceți codul de invitație (obligatoriu)",
  输入正确的金额: "Introduceți o sumă validă",
  法币充值: "Depunere fiat",
  卢比充值: "Depunere rupie indiană",
  请输入法币: "Introduceți suma fiat",
  请输入IFSC: "Introduceți codul IFSC",
  "银行编码(选填)": "Cod bancar (opțional)",
  请输入银行编码: "Introduceți codul bancar",
  请输入大于8位数的密码: "Introduceți o parolă cu mai mult de 8 caractere",
  添加成功: "Adăugat cu succes",
  "60秒": "60 secunde",
  "180秒": "180 secunde",
  "300秒": "300 secunde",
  "2次密码不一致": "Parolele nu se potrivesc",
  输入提币数量: "Introduceți cantitatea de retragere",
  图片格式不正确: "Format imagine invalid",
  图片大于20M: "Imaginea este mai mare de 20 MB",
  请设置委托价格: "Setați un preț pentru ordin",
  输入资金密码: "Introduceți parola activelor",
  验证码错误: "Cod de verificare incorect",
  充值拒绝: "Depunere respinsă",
  请输入SSN: "Introduceți SSN-ul",
  结算完成: "Decontare finalizată",
  继续下单: "Continuă comanda",
  限价: "Ordin limită",
  买入价格: "Preț de cumpărare",
  买入量: "Cantitate de cumpărare",
  卖出价格: "Preț de vânzare",
  卖出量: "Cantitate de vânzare",
  买入: "Cumpără",
  卖出: "Vinde",
  订单创建成功: "Comandă creată cu succes",
  币币买入支出: "Cheltuială cumpărare spot",
  币币买入支出退还: "Rambursare cheltuială cumpărare spot",
  币币买入获得: "Obținut din cumpărare spot",
  币币卖出支出: "Cheltuială vânzare spot",
  币币卖出支出退还: "Rambursare cheltuială vânzare spot",
  币币卖出获得: "Obținut din vânzare spot",
  币币交易手续费: "Comision tranzacție spot",
  请输入限价: "Introduceți prețul limită",
  成交: "Executat",
  等待成交: "Așteaptă execuția",
  交易完成: "Tranzacție finalizată",
  被取消: "Anulat",
  交易时间: "Timp tranzacție",
  法币交易: "Tranzacție fiat",
  法币出售: "Vânzare fiat",

  两次密码不一致: "Parolele nu se potrivesc",
  再次输入账户密码: "Introduceți din nou parola contului",

  美国: "Statele Unite ale Americii",
  韩国: "Coreea de Sud",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Yemen",
  美属维尔京群岛: "Insulele Virgine Americane",
  英属处女群岛: "Insulele Virgine Britanice",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "Regatul Unit",
  阿拉伯联合酋长国: "Emiratele Arabe Unite",
  乌克兰: "Ucraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Insulele Turks și Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turcia",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad și Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Timorul de Est",
  泰国: "Thailanda",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tadjikistan",
  中国台湾: "Taiwan",
  叙利亚: "Siria",
  瑞士: "Elveția",
  瑞典: "Suedia",
  斯威士兰: "Eswatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spania",
  南非: "Africa de Sud",
  索马里: "Somalia",
  所罗门群岛: "Insulele Solomon",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovacia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (partea olandeză)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Arabia Saudită",
  圣多美和普林西比: "São Tomé și Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts și Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent și Grenadinele",
  圣彼埃尔和密克隆岛: "Saint-Pierre și Miquelon",
  圣露西亚: "Sfânta Lucia",
  圣基茨和尼维斯: "Saint Kitts și Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Rusia",
  罗马尼亚: "România",
  留尼汪: "Réunion",
  刚果共和国: "Republica Congo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugalia",
  波兰: "Polonia",
  菲律宾: "Filipine",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Noua Guinee",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norvegia",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Noua Zeelandă",
  新喀里多尼亚: "Noua Caledonie",
  荷属安德列斯群岛: "Antilele Olandeze",
  荷兰: "Țările de Jos",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambic",
  摩洛哥: "Maroc",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Muntenegru",
  蒙古: "Mongolia",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Mexic",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Insulele Mariane",
  马提尼克: "Martinica",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldive",
  马来西亚: "Malaezia",
  马拉维: "Malawi",
  马达加斯加: "Madagascar",
  马其顿: "Macedonia de Nord",
  中国澳门: "Macao",
  卢森堡: "Luxemburg",
  立陶宛: "Lituania",
  列支敦士登: "Liechtenstein",
  利比亚: "Libia",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Liban",
  拉脱维亚: "Letonia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kârgâzstan",
  科威特: "Kuweit",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazahstan",
  约旦: "Iordania",
  日本: "Japonia",
  牙买加: "Jamaica",
  象牙海岸: "Coasta de Fildeș",
  意大利: "Italia",
  以色列: "Israel",
  爱尔兰: "Irlanda",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonezia",
  印度: "India",
  冰岛: "Islanda",
  匈牙利: "Ungaria",
  中国香港: "Hong Kong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guineea-Bissau",
  几内亚: "Guineea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadelupa",
  格林纳达: "Grenada",
  格陵兰岛: "Groenlanda",
  希腊: "Grecia",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Germania",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Polinezia Franceză",
  法属圭亚那: "Guyana Franceză",
  法国: "Franța",
  芬兰: "Finlanda",
  斐济: "Fiji",
  法罗群岛: "Insulele Feroe",
  埃塞俄比亚: "Etiopia",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Eritreea",
  赤道几内亚: "Guineea Ecuatorială",
  萨尔瓦多: "El Salvador",
  埃及: "Egipt",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Republica Dominicană",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Danemarca",
  捷克: "Cehia",
  塞浦路斯: "Cipru",
  库拉索: "Curaçao",
  古巴: "Cuba",
  克罗地亚: "Croația",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Coasta de Fildeș",
  库克群岛: "Insulele Cook",
  科摩罗: "Comore",
  哥伦比亚: "Columbia",
  智利: "Chile",
  乍得: "Ciad",
  中非共和国: "Republica Centrafricană",
  佛得角: "Capul Verde",
  开曼群岛: "Insulele Cayman",
  开普: "Cape",
  加拿大: "Canada",
  喀麦隆: "Camerun",
  柬埔寨: "Cambodgia",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brazilia",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia și Herțegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgia",
  白俄罗斯: "Belarus",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbaidjan",
  奥地利: "Austria",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua și Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Samoa Americană",
  阿尔及利亚: "Algeria",
  中国: "China",
  余额不足: "Sold insuficient",
  最低购买: "Cumpărare minimă",
  最高购买: "Cumpărare maximă",
  下单成功: "Comandă plasată cu succes",
  平仓成功: "Poziție închisă cu succes",
  请输入正确的平仓数量: "Introduceți o cantitate validă de închidere",
  加仓成功: "Poziție mărită cu succes",
  请输入正确的加仓金额: "Introduceți o sumă validă pentru mărirea poziției",
  收藏成功: "Adăugat la favorite",
  取消收藏成功: "Eliminat din favorite",
  加密币永续: "Perpetual criptomonedă",
  外汇永续: "Perpetual valutar",
  期权账户: "Cont opțiuni",
  快捷卖币: "Vânzare rapidă criptomonedă",

  托管资金: "Fonduri gestionate",
  托管中: "În gestiune",
  预计日收益: "Randament zilnic estimat",
  累计收益: "Randament total",
  周期: "Durată",
  日收益: "Randament zilnic",
  限额: "Limită",
  立即托管: "Începeți gestiunea acum",
  "已鎖定 請聯繫客服": "Blocat. Contactați serviciul clienți.",
  产品列表: "Listă produse",
  规则: "Reguli",
  创建订单: "Creați comandă",
  产品名称: "Nume produs",
  托管周期: "Perioadă de gestiune",
  等级限制: "Restricție nivel",
  托管金额: "Sumă gestionată",
  限额: "Limită",
  余额: "Sold",
  购买日: "Data cumpărării",
  起息日: "Data începerii dobânzii",
  派息时间: "Timp plată dobândă",
  每天: "Zilnic",
  计息结束日: "Data încheierii dobânzii",
  每日收益: "Randament zilnic",
  预计收益: "Randament estimat",
  "收益将自动发送至您的余额账户;":
    "Randamentul va fi trimis automat în soldul contului dvs.;",
  "您的资金没有任何风险;": "Fondurile dvs. nu sunt expuse niciunui risc;",
  "365*24小时不断地工作;": "Funcționează 24/7, 365 de zile pe an;",
  托管中: "În gestiune",
  结束: "Încheiat",
  今日收益: "Randamentul de azi",
  剩余周期: "Durată rămasă",
  进行中: "Activ",
  已发放: "Plătit",
  信誉分: "Puncte reputație",

  复制成功: "Copiat cu succes",
  VIP权益: "Beneficii VIP",
  旧密码: "Parola veche",
  请输入旧密码: "Introduceți parola veche",
  "忘记旧密码请联系客服重置。":
    "Dacă ați uitat parola veche, vă rugăm să contactați serviciul clienți pentru a o reseta.",
  去升级: "Actualizați",
  描述: "Descriere",
  实际存款金额: "Suma reală a depozitului",
  升级礼金: "Bonus de actualizare",
  隔夜利息: "Dobânda overnight (swap)",
  自动结算: "Decontare automată",
  等级规则: "Reguli de nivel",
  "WEB3.0币持有数据收益": "Randamentul datelor deținerii monedelor WEB3.0",
  总生产: "Producția totală",
  有效节点: "Noduri active",
  参与人: "Participanți",
  用户收益: "Randamentul utilizatorului",
  "流动性WEB3.0输出": "Ieșirea lichidității WEB3.0",
  总资产: "Active totale",

  ETHAI持有数据收益: "Randamentul datelor de deținere ETHAI",
  AI量化流动性: "Lichiditate cantitativă AI",
  现货买入手续费: "Comision de cumpărare spot",
  现货支出: "Cheltuială spot",
  现货资金费率: "Rată de finanțare spot",
  现货卖出手续费: "Comision de vânzare spot",
  现货收入: "Venit spot",
  外汇合约支出: "Cheltuială contract valutar",
  外汇合约买入手续费: "Comision de cumpărare contract valutar",
  外汇合约资金费率: "Rată de finanțare contract valutar",
  外汇合约卖出手续费: "Comision de vânzare contract valutar",
  外汇合约收入: "Venit din contract valutar",
  理财购买: "Cumpărare produs financiar",
  VIP理财日收益: "Randament zilnic produs financiar VIP",
  VIP理财隔夜利息: "Dobândă overnight produs financiar VIP",
  VIP本金返还: "Returnare capital VIP",
  VIP彩金发放: "Distribuire bonus VIP",
  VIP彩金抵扣: "Deducere bonus VIP",
  隔夜利息: "Dobândă overnight",
  设置资产密码: "Setare parolă active",

  锁仓挖矿: "Mining cu blocare",
  一站式理财服务: "Serviciu financiar all-in-one",
  产品: "Produse",
  客服中心: "Centru de suport clienți",
  贷款: "Împrumuturi",
  挖矿赚不停: "Câștiguri continue din mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Miningul cu blocare constă în depunerea USDT (USD:1USDT=1USD) în echipamentele de mining de mare putere ale platformei pentru a obține randamente în pool-ul de mining al platformei.",
  产品优势: "Avantajele produsului",
  随存随取: "Depunere și retragere oricând",
  锁仓周期: "Perioadă de blocare",
  每日下发: "Distribuție zilnică",
  随机空投: "Airdrop aleatoriu",
  "100%资金安全保障": "Garanție de siguranță a fondurilor 100%",
  "100%节假日收益不间断":
    "Randamente continue 100% chiar și în zilele de sărbătoare",
  成功锁仓后当天产出: "Randament generat în aceeași zi după blocare reușită",
  关于违约金: "Despre penalizare",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Dacă doriți retragerea capitalului înainte de scadență, se va aplica o penalizare. Penalizare = procent penalizare × zile rămase × sumă blocată.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Exemplu: rata penalizării este 5%, mai sunt 3 zile până la scadență, iar suma blocată este 10000U (USDT/USD). Penalizare = 5%×3×10000=1500U, iar capitalul returnat este 15000U-1500U.",
  收益计算: "Calculul profitului",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platforma oferă mai multe produse financiare de mining cu blocare. Calculul profitului este următorul, de exemplu:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Dacă un utilizator blochează 10000U (USDT, USD) și alege un produs de 7 zile cu randament zilnic de 0,7%~1,8%, câștigul zilnic este următorul:",
  "最低:10000Ux0.7%=70U;": "Minim: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maxim: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "După 7 zile se poate obține un profit de 490U~1260U. Veniturile sunt distribuite zilnic, iar capitalul este transferat automat în cont la scadență.",
  正在托管的资金: "Fonduri în administrare",
  签到: "Check-in zilnic",
  锁仓订单: "Comenzi blocate",
  预计今日收益: "Profit estimat azi",
  累计收益: "Profit cumulativ",
  托管中的订单: "Comenzi în administrare",
  单笔最少: "Sumă minimă per comandă",
  单笔最多: "Sumă maximă per comandă",
  日收益率: "Rată zilnică de randament",
  说明: "Descriere",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Datele sunt calculate în fusul GMT+8<br>2. Profitul zilnic se calculează pe baza tuturor ordinelor decontate între 00:00-23:59 GMT+8<br>3. Veniturile sunt distribuite a doua zi între 00:00-00:10 GMT+8.",
  知道了: "Am înțeles",
  锁仓: "Blochează",
  派息时间: "Timp distribuire",
  每日: "Zilnic",
  托管资金: "Fonduri în custodie",
  到期返回: "Returnare la scadență",
  提前赎回: "Răscumpărare anticipată",
  预计收益: "Profit estimat",
  认购: "Subscriere",
  热门: "Popular",
  数字货币: "Criptomonede",
  贵金属: "Metale prețioase",
  大宗商品: "Mărfuri",
  持仓明细: "Detalii poziții",
  历史明细: "Istoric",
  当前价: "Preț curent",
  "↑买涨": "↑ Cumpără creștere",
  "↓买跌": "↓ Cumpără scădere",
  显示全部: "Afișează tot",
  买入金额: "Sumă cumpărare",
  方向: "Direcție",
  收益: "Profit",
  预期收益: "Profit estimat",
  估用保证金: "Marjă estimată",
  确认下单: "Confirmă comanda",
  锁定: "Blocat",
  账户总资产: "Total active cont",
  明细: "Detalii",
  今日收益: "Profit azi",
  仓位保证金: "Marjă poziție",
  持有仓位: "Poziții deținute",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Suma blocată = totalul comenzilor de mining cu blocare nefinalizate",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Datele sunt calculate în GMT+8<br>2. Profitul zilnic se calculează pe baza ordinelor decontate",
  充值方式: "Metodă depunere",
  银行汇款: "Transfer bancar",
  "银行汇款请联系客服进行操作!": "Contactați suportul pentru transfer bancar!",
  提款方式: "Metodă retragere",
  "银行提款请联系客服进行操作!":
    "Contactați suportul pentru retragere bancară!",
  资金明细: "Detalii fonduri",
  提现记录: "Istoric retrageri",
  拒绝: "Respins",
  通过: "Aprobat",
  拒绝原因: "Motiv respingere",

  消息公告: "Anunțuri",
  订单: "Comenzi",
  个人中心: "Centru personal",
  "未到期赎回需支付一定的违约金!":
    "Răscumpărarea înainte de scadență implică plata unei penalități.",

  请输入区号: "Vă rugăm să introduceți prefixul",
  "请选择国家/地区": "Vă rugăm să selectați o țară/regiune",

  今日开盘: "Deschiderea de astăzi",
  昨日收盘: "Închiderea de ieri",

  实名认证即送: "Primește imediat după verificarea identității",
  立即认证: "Verifică acum",
  新用户礼包: "Pachet cadou pentru utilizatori noi",
  完成新人任务领取:
    "Finalizează sarcinile pentru utilizatori noi pentru a primi",
  认证: "Verifică",
  时间周期: "Perioadă de timp",
  支付金额: "Sumă de plată",
  已平仓: "Închis",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Pachet de bun venit MGBX pentru utilizatori noi: fiecare utilizator poate primi maximum",
  我已经阅读并同意: "Am citit și sunt de acord cu",
  隐私政策: "Politica de confidențialitate",

  放弃奖励离开: "Renunță la recompensă și părăsește",
  继续注册: "Continuă înregistrarea",
  分钟: "Minute",

  "请先勾选隐私政策!":
    "Vă rugăm să consultați mai întâi Politica de confidențialitate!",
  添加其他到自选: "Adaugă altele în lista de urmărire",
  充值最高可得: "Alimentează contul și primește până la 30.000 $.",

  请输入格式正确的手机号:
    "Vă rugăm să introduceți un număr de telefon mobil valid.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 罗马尼亚语



// WEBPACK FOOTER //
// ./src/lang/lmny.js